import React from "react";
import { Stack, Box, Typography, Hidden } from "@mui/material";

export const AboutUsContent = ({ translate }) => {
  return (
    <Stack
      direction={{ xs: "column", lg: "row" }}
      justifyContent={{ xs: "start", lg: "center" }}
      spacing={2}
    >
      <Box data-aos="fade-up" data-aos-offset="200">
        <Box sx={{ marginBottom: "30px" }}>
          <Box>
            <Typography variant="h5" gutterBottom>
              <b>{translate("homeContentSecondHead")}</b>
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ textIndent: "50px" }}>
              {translate("homeContentSecondBody")}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography variant="h5" gutterBottom>
            <b>{translate("aboutUsContentHead")}</b>
          </Typography>
          <Typography variant="body2" sx={{ textIndent: "50px" }}>
            {translate("aboutUsContentBody")}
          </Typography>
        </Box>
      </Box>
      <Hidden lgDown>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          data-aos="fade-up"
          data-aos-offset="200"
        >
          <img
            src="/images/about-image4.jpg"
            alt="About images"
            width={500}
            height={350}
            loading="lazy"
          />
        </Box>
      </Hidden>
      <Hidden lgUp>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          data-aos="fade-up"
          data-aos-offset="200"
        >
          <img
            src="/images/about-image4.jpg"
            alt="About images"
            width={350}
            height={250}
            loading="lazy"
          />
        </Box>
      </Hidden>
    </Stack>
  );
};
